import { Module } from 'vuex';
import { RootState } from '@/store/state';
import actions from '@/store/modules/cart/actions';
import mutations from '@/store/modules/cart/mutations';
import state, { CartState } from '@/store/modules/cart/state';

const CartModule: Module<CartState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default CartModule;
